import * as z from "zod";

export const updateSupportSettings = {
  name: "updateSupportSettings" as const,
  input: z.any(),
  output: z.null(),
};
